import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { CheckCircleIcon, ChevronDownIcon, ChevronUpIcon, MinusCircleIcon } from '@heroicons/react/24/outline'
import ChangeSetPreview from './ChangeSetPreview'

const noop = () => {}

// VH-227: a decided change set (confirmed, superseded, rejected) as one line under its
// message; the before/after is one click away, read-only.
export function ChangeSetNote({ changeSet }) {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)
  const confirmed = changeSet.status === 'confirmed'
  const decidedOps = changeSet.operations.filter((op) => op.confirmed === true)
  const count = confirmed && decidedOps.length > 0 ? decidedOps.length : changeSet.operations.length
  const Icon = confirmed ? CheckCircleIcon : MinusCircleIcon

  return (
    <div data-testid={`change-set-note-${changeSet.id}`}>
      <p className={`flex flex-wrap items-center gap-x-1 text-xs ${confirmed ? 'text-green-700' : 'text-gray-500'}`}>
        <Icon className="h-4 w-4 shrink-0" />
        <span className="font-medium">{t(`healthCycle.changeSet.status.${changeSet.status}`, changeSet.status)}</span>
        <span>· {t('healthCycle.changeSet.changeCount', { count })}</span>
        <span>·</span>
        <button
          type="button"
          className="inline-flex items-center text-purple-700 hover:text-purple-900"
          onClick={() => setOpen((v) => !v)}
          aria-expanded={open}
        >
          {open ? t('healthCycle.changeSet.hideDetails') : t('healthCycle.changeSet.details')}
          {open ? <ChevronUpIcon className="h-3 w-3 ml-0.5" /> : <ChevronDownIcon className="h-3 w-3 ml-0.5" />}
        </button>
      </p>
      {open && (
        <div className="mt-2">
          <ChangeSetPreview changeSet={changeSet} readOnly onConfirm={noop} onReject={noop} />
        </div>
      )}
    </div>
  )
}

export default ChangeSetNote
